import Paper from "@mui/material/Paper";
import FormGeneratorComponent from "helper/FormGenerator";
import React, { useEffect, useState } from 'react';
import { BulkTicketForm, BulkTicketWrapper, BulkTicketWrapperTitle, ValidationIcon, ValidationItems, ValidationWrapper } from "./Theme";

const BulkTicket = ({
  currentFormData,
  answerFormData,
  updateBulkFormDataHandler,
  errors = [],
}) => {
  const [formData, setFormData] = useState([]);


  useEffect(() => {
    if (!currentFormData) return;
    const updatedFormData = currentFormData.length > 0 && currentFormData.map((item, i) => {
      if (item?.options) {
        return {
          ...item,
          options: item?.options?.map((val) => {
            return {
              ...val,
              key: `${val.key}`,
            }
          })
        }
      } else {
        return {
          ...item,
        }
      }
    })
    setFormData(updatedFormData)
  }, [currentFormData])

  return (
    <Paper
      sx={{
        minHeight: "278px",
        margin: "33px 0 0 0",
        borderRadius: "10px",
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? "#1A2027" : "#fff",
      }}
    >
      <BulkTicketWrapper>
        <BulkTicketWrapperTitle>
          <span>Parent Info</span>
        </BulkTicketWrapperTitle>
      </BulkTicketWrapper>
      {errors?.length > 0 &&
        <ValidationWrapper>
          <ValidationIcon />
          <ValidationItems>
            {errors?.map((error) => error?.errorMsg && (
              <li>{error.errorMsg}</li>
            ))}
          </ValidationItems>
        </ValidationWrapper>
      }
      <BulkTicketForm>
        {formData?.length > 0 && (
          <FormGeneratorComponent
            formStructure={[...formData]}
            syncValuesWithFormik={updateBulkFormDataHandler}
            answerData={answerFormData}
          />
        )}
      </BulkTicketForm>
    </Paper>
  )
}

export default BulkTicket